import React, { PureComponent, Fragment } from 'react'
import { Menu, Input, Icon, Form, Button, Grid, Header, Modal, Label } from 'semantic-ui-react'
import _ from 'lodash'
import firebase from '../../../config/firebase'

class AddDriverToSegmentForm extends PureComponent {

  constructor(props) {
    super(props)
    this.state = {
      save: false,
      search: '',
      selectedDriverKeys: []
    }
  }

  onSave = async () => {
    const { selectedDriverKeys } = this.state
    const { driverSegment, onClose } = this.props
    const driverObj = {}

    await this.setStateAsync({ saving: true })

    selectedDriverKeys.map((driverKey, index) => {
      driverObj[`/deliverers/${driverKey}/driver_segment`] = driverSegment.id
      return driverObj
    })

    await firebase.database().ref().update(driverObj)
    await this.setStateAsync({ saving: false, selectedDriverKeys: [] })

    onClose()
  }

  setStateAsync = state => {
    return new Promise(resolve => this.setState(state, resolve))
  }

  onDriverClick = driverUID => {
    const { selectedDriverKeys } = this.state

    if (selectedDriverKeys.includes(driverUID)) {
      this.setState({ selectedDriverKeys: selectedDriverKeys.filter(key => driverUID !== key) })
    } else {
      this.setState({ selectedDriverKeys: selectedDriverKeys.concat(driverUID) })
    }
  }

  onRemove = driverUID => {
    const { selectedDriverKeys } = this.state

    this.setState({ selectedDriverKeys: selectedDriverKeys.filter(key => key !== driverUID) })
  }

  renderDriver = driver => {
    const { selectedDriverKeys } = this.state
    const { driverSegments } = this.props

    return (
      <Menu.Item
        key={driver.key}
        active={selectedDriverKeys && selectedDriverKeys.includes(driver.driverUID)}
        onClick={() => this.onDriverClick(driver.driverUID)}
        style={styles.driver}
      >
        <div style={styles.driverRow} >
          <div style={styles.driverName}>
            {`${driver.family_name} ${driver.first_name}`}
            { driverSegments[driver.driver_segment] ? <Label size='tiny' style={{ marginLeft: 10}}>{driverSegments[driver.driver_segment].name}</Label> : ''}
          </div>
          {
            selectedDriverKeys.includes(driver.driverUID) && (
              <div style={styles.checkContainer} >
                <Icon name="check" color="green" />
              </div>
            )
          }
        </div>
      </Menu.Item>
    )
  }

  renderDrivers = () => {
    const { drivers } = this.props
    const { search } = this.state

    let displayDrivers = Object.values(drivers).filter(driver => {
      const driverName = (`${driver.family_name} ${driver.first_name}`).toLowerCase()
      const searchText = search.toLowerCase().trim()

      return driverName.includes(searchText)
    })

    displayDrivers = _.sortBy(displayDrivers, 'driverUID').reverse()

    return (
      <div>
        <Input
          type="text"
          placeholder="Search"
          name="search-driver"
          onChange={e => this.setState({ search: e.target.value })}
          icon="search"
          style={{ width: '100%', marginTop: 10 }}
        />
        <Menu vertical style={styles.menu}>
          {
            displayDrivers.map((driver, index) => (
              <Fragment key={index}>
                {this.renderDriver(driver)}
              </Fragment>
            ))
          }
        </Menu>
      </div>
    )
  }

  renderSelectedDrivers = () => {
    const { selectedDriverKeys } = this.state
    const { drivers, driverSegments } = this.props

    return (
      <div style={{ marginTop: 20 }}>
        <Header as='h3' style={{ marginBottom: 22 }}>
          List of Selected Driver
        </Header>
        {
          selectedDriverKeys.map((driverKey, index) => {
            let driver = _.find(drivers, ['driverUID', driverKey])
            return <div style={styles.selectedDriversContainer} key={index}>
                      <div style={styles.driverItem}>
                        {`${driver.family_name} ${driver.first_name}`}
                        { driverSegments[driver.driver_segment] ? <Label size='tiny' style={{ marginLeft: 10}}>{driverSegments[driver.driver_segment].name}</Label> : ''}
                      </div>
                      <div style={{ marginLeft: 8 }}>
                        <Button icon="remove" color="red" onClick={() => this.onRemove(driverKey)} />
                      </div>
                    </div>
          })
        }
      </div>
    )
  }

  render() {
    const { visible, onClose, loading } = this.props
    const { saving, selectedDriverKeys } = this.state

    return(
      <Modal open={visible} size="small" style={{ marginTop: 0 }}>
        <Modal.Header content="Add Driver To Segment" />
        <Modal.Content>
          <Form>
            <Grid columns={2}>
              <Grid.Row>
                <Grid.Column>{this.renderDrivers()}</Grid.Column>
                <Grid.Column>{this.renderSelectedDrivers()}</Grid.Column>
              </Grid.Row>
            </Grid>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onClose}
            disabled={loading}
          >
            Close
          </Button>
          <Button
            icon
            color="black"
            onClick={this.onSave}
            loading={loading}
            disabled={saving || _.size(selectedDriverKeys) === 0}
          >
            <Icon name="checkmark" /> Save
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

export default AddDriverToSegmentForm

const styles = {
  menu: {
    maxHeight: 'calc(100vh - 350px)',
    overflow: 'auto',
    width: '100%'
  },
  driver: {
    padding: '13px 10px',
    borderRadius: 0
  },
  driverRow: {
    flexDirection: 'row',
    alignItems: 'center',
    display: 'flex',
  },
  driverName: {
    whiteSpace: 'normal',
    wordBreak: 'break-all',
    lineHeight: '1.3',
    display: 'flex',
    flex: 1,
    fontSize: 15,
  },
  checkContainer: {
    display: 'flex',
    width: 20,
    justifyContent: 'flex-end',
    marginLeft: 5,
  },
  selectedDriversContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  driverItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    userSelect: 'none',
    padding: 10,
    margin: '4px 0px',
    background: 'rgb(224, 225, 226)',
    width: '100%',
    borderRadius: 5,
    color: 'rgba(0, 0, 0, 0.8)',
  }
}



// WEBPACK FOOTER //
// ./src/components/drivers/forms/addDriverToSegmentForm.js